import { School } from '../school';
import { Student } from '../student';
import { Event } from '../event/event.model';



export class EventReservation {

    constructor(
        public school?: School,
        public id?: number,
        public event?: Event,
        public student?: Student,
        public price?: number,
        public totalPaid?: number,
        public backofficeSessionId?: string,
        public payedExternally?: boolean
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event-reservation/event-reservation.model.ts